module.exports = __webpack_public_path__ + "img/login.58e3e47c.jpeg";